import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { GovernmentProjectsProvider } from './context/government-projects-context';
import { GovernmentProjectDetailComponent } from './government-project-detail-component';

export function GovernmentProjectDetailFactory() {
    return (
        <BaseLayoutFactory>
            <GovernmentProjectsProvider>
                <GovernmentProjectDetailComponent />
            </GovernmentProjectsProvider>
        </BaseLayoutFactory>
    );
}
